import XLSX from 'xlsx'

const MyParseExcel = {
  install (Vue) {
    Vue.parseExcel = file => new Promise((resolve) => {
      const dataToReturn = []
      const reader = new FileReader()

      reader.onload = (e) => {
        const data = e.target.result
        const workbook = XLSX.read(data, {
          type: 'binary'
        })
        workbook.SheetNames.forEach((sheetName) => {
          const XLRowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
          const jsonObject = JSON.stringify(XLRowObject)
          dataToReturn.push(JSON.parse(jsonObject))
        })
        return resolve(dataToReturn)
      }

      reader.onerror = () => resolve(dataToReturn)

      reader.readAsBinaryString(file)
    })
  }
}

export default MyParseExcel
